<template>
<div class="notifications" :class="{'notifications--active': isListOpen}">

  <button class="notifications__title" @click="toggleList">
    <div class="notifications__icon">
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="14" height="17" viewBox="0 0 14 17"><defs><path id="y5cha" d="M48.28 45.86c1.03 1.97 4.39.6 3.75-1.5-1.32.47-3.02 1.25-3.75 1.5z"/><path id="y5chb" d="M53.41 39.91a72.4 72.4 0 0 1-9.14 3.64c-.14 1.12-.3 2.33-.46 3.43a90.95 90.95 0 0 0 12.26-4.76 96.23 96.23 0 0 0-2.66-2.31z"/><path id="y5chc" d="M46.27 32.58c-.54-.98-1.94-.58-1.66.65.2-.17 1.06-.6 1.66-.65z"/><path id="y5chd" d="M50.85 37.46c-1.05-1.79-2.73-3.41-4.16-3.82 1.6-.41 3.78 1.14 4.16 3.82zm2.28 2.05c-1.5-1.63-3.29-8.21-7.63-6.47-4.39 1.77-1.4 8.17-1.37 9.97 1.8-.42 6.19-1.93 9-3.5z"/></defs><g><g transform="rotate(21 110.02 -86.1)"><g><g><use fill="#fff" xlink:href="#y5cha"/></g><g><use fill="#fff" xlink:href="#y5chb"/></g><g><use fill="#fff" xlink:href="#y5chc"/></g><g><use fill="#fff" xlink:href="#y5chd"/></g></g></g></g></svg>
      <span class="notifications__counter" v-if="notifications.length">{{notifications.length}}</span>
    </div>
    <span class="notifications__text" :class="{'notifications__text--padding-left': !notifications.length}">У Вас {{notifications.length || 'нет'}} новых уведомлений</span>
  </button>

  <ul v-if="isListOpen" class="notifications__list">
      <li v-for="notification in notifications" :key="notification.id" class="notifications__item">
          <a v-if="notification.company_id == companyId" :href="getNotifyLink(notification)" class="notifications__link">
            <h5>{{getNotificationCompany(notification)}}</h5>
            {{getNotifyText(notification)}}
          </a>
          <span v-else class="notifications__link notifications__link--without-link">
            <h5>{{getNotificationCompany(notification)}}</h5>
            {{getNotifyText(notification)}}
          </span>
          <button class="notifications__cancel" @click="remove(notification.id)"></button>
      </li>
  </ul>
</div>
</template>

<script>
export default {
  data() {
    return { isListOpen: false, isLoading: false };
  },

  props: ["companyId"],

  computed: {
    isHasNotify() {
      return !!this.$store.state.notifications.length;
    },
    notifications() {
      return this.$store.state.notifications;
    }
  },

  methods: {
    getNotifyLink: notification => {
      switch (notification.type) {
        case CONST.notifications.status.taskCreated:
        case CONST.notifications.status.commentCreated:
        case CONST.notifications.status.taskCanceled:
        case CONST.notifications.status.taskClosed:
        case CONST.notifications.status.taskStatusChanged:
          return "/tasks/" + notification.object_id;
          break;
        case CONST.notifications.status.listDocsUpdated:
          return "/documents/";
          break;
        case CONST.notifications.status.listDocsUpdatedClients:
          return "/purchase-documents/";
          break;
        default:
          break;
      }
    },

    getNotificationCompany: notification => {
      return `«${notification.company_name}»`;
    },

    getNotifyText: notification => {
      switch (notification.type) {
        case CONST.notifications.status.taskCreated:
          return "Новая задача «" + notification.task_name + "»";
          break;
        case CONST.notifications.status.commentCreated:
          return "Новый комментарий к задаче «" + notification.task_name + "»";
          break;
        case CONST.notifications.status.taskCanceled:
          return "Задача «" + notification.task_name + "» отменена";
          break;
        case CONST.notifications.status.taskClosed:
          return "Задача «" + notification.task_name + "» закрыта";
          break;
        case CONST.notifications.status.taskStatusChanged:
          return "Статус задачи «" + notification.task_name + "» изменен";
          break;
        case CONST.notifications.status.listDocsUpdated:
          return "Обновился срок предоставления документов поставщиков";
          break;
        case CONST.notifications.status.listDocsUpdatedClients:
          return "Обновился срок предоставления документов покупателей";
          break;
        default:
          break;
      }
    },

    remove(id) {
      this.isLoading = true;

      axios
        .post("/notifications/" + id + "/read")
        .then(() => {
          const newNotifications = this.$store.state.notifications.filter(
            notify => notify.id !== id
          );
          this.$store.commit("setNotifications", newNotifications);
          this.isLoading = false;
        })
        .catch(() => {
          iziToast.error({
            title: "Ошибка",
            message: "API недоступен",
            backgroundColor: "#ff6736",
            position: "topRight",
            theme: "dark",
            timeout: false,
            icon: "material-icons",
            iconText: "error"
          });
          this.isLoading = false;
        });
    },

    toggleList() {
      if (this.isHasNotify) {
        this.isListOpen = !this.isListOpen;
      }
    }
  }
};
</script>
